import React, { Component } from 'react';
import styled from 'styled-components';
import { Layout, Breakpoint } from '../../values';

import Logo from '../Logo';
import MenuIcon from './MenuIcon';

import Demo from '../Demo';
import { dark, primary, white } from 'react-components/dist/values/colors/colors';
import { primaryFont } from 'react-components/dist/values/fonts/fonts';
import { Button } from 'react-components/dist/buttons/Button';

const Wrapper = styled.div`
  position: fixed;
  z-index: 999999999;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: ${props => props.bg};
  transition: 0.3s background-color;
`;

const Inner = styled.div`
  height: 100%;
  width: 100%;
  max-width: ${Layout.maxWidth}px;
  display: flex;
  justify-content: center;
  & > div {
    width: 100%;
    margin: ${Layout.margin};
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  & > span {
    position: absolute;
  }
`;

const Left = styled.div`
  height: 100%;
  width: 120px;
  padding: 12px 0;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }
`;
const Right = styled.div``;

const Desktop = styled.div`
  & > ul {
    display: flex;
    color: ${white};
    font: ${primaryFont.large};
    list-style-type: none;
    align-items: center;
    font-size: 0.8em;
    & > li {
      margin-left: 24px;
      &:hover {
        cursor: pointer;
        color: ${primary};
      }
    }
    & > li > a {
      color: ${white};
      text-decoration: none;
      &:hover {
        cursor: pointer;
        color: ${primary};
      }
    }
  }
  @media (max-width: ${Breakpoint.medium}px) {
    display: none;
  }
`;
const Mobile = styled.div`
  display: none;
  & li {
    padding: 12px;
  }
  @media (max-width: ${Breakpoint.medium}px) {
    display: block;
  }
`;

const MenuContainer = styled.div`
  max-height: ${props => (props.close ? 0 : 999999999)}px;
  transition: 0.3s max-height;
  overflow: hidden;
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  background-color: ${dark};
  border-bottom-left-radius: 8px;
  & > ul {
    padding: 0;
    text-align: right;
    list-style-type: none;
    color: ${white};
    font: ${primaryFont.large};
    & > li {
      padding: 5px 32px;
    }
  }
`;

const menuTitle = {
  en: ['MAG', 'FRANÇAIS', 'REQUEST DEMO', 'MAIN WEBSITE'],
  fr: ['MAG', 'ENGLISH', 'DEMANDEZ UNE DÉMO', 'SITE WEB PRINCIPAL']
};

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opacity: 0,
      mobileMenuClose: true,
      hideForm: true
    };
    this.menu = React.createRef();

    let menuItems = this.props.lang === 'fr' ? menuTitle.fr : menuTitle.en;
    this.tabs = (
      <ul>
        <li
          onClick={() => {
            return false;
          }}
          style={{ color: primary }}
        >
          {menuItems[0]}
        </li>
        <li>
          <a
            id="langSwitcher"
            href={window.currentPost ? window.currentPostTranslation : this.props.lang === 'fr' ? '/' : '/fr/'}
          >
            {menuItems[1]}
          </a>
        </li>
        <li>
          <Button onClick={() => this.showForm()}>{menuItems[2]}</Button>
        </li>
        <li>
          <a href={this.props.lang === 'fr' ? 'https://deepsight.ca/fr' : 'https://deepsight.ca'}>{menuItems[3]}</a>
        </li>
      </ul>
    );
  }
  componentDidMount() {
    window.addEventListener('scroll', e => {
      this.setState({
        opacity: window.scrollY
      });
    });
    this.setState({
      opacity: window.scrollY
    });
    this.menu.current.style.opacity = 1;
  }

  goto = (section, curve) => {
    let elementTop = document.getElementById(section).getBoundingClientRect().top + window.scrollY;

    let offset = 75;
    if (curve) offset = 275;

    window.scrollTo({
      top: elementTop - offset,
      behavior: 'smooth'
    });
  };
  top = () => {
    window.location.href = '/';
  };

  toggleMenu = () => {
    this.setState({
      mobileMenuClose: !this.state.mobileMenuClose
    });
  };

  showForm = () => {
    this.setState({
      hideForm: !this.state.hideForm
    });
  };

  render() {
    return (
      <Wrapper
id="menu"
ref={this.menu}
bg={this.state.opacity >= 100 ? dark : dark + this.state.opacity}>
        <Inner>
          <span>
            <Demo
lang={this.props.lang}
onChange={() => this.showForm()}
hide={this.state.hideForm} />
          </span>
          <div>
            <Left>
              <a href={this.props.lang === 'en' ? '/' : '/fr/'}>
                <Logo light />
              </a>
            </Left>
            <Right>
              <Desktop>{this.tabs}</Desktop>
              <Mobile onClick={() => this.toggleMenu()}>
                <MenuIcon
color={primary}
close={this.state.mobileMenuClose} />
                <MenuContainer close={this.state.mobileMenuClose}>{this.tabs}</MenuContainer>
              </Mobile>
            </Right>
          </div>
        </Inner>
      </Wrapper>
    );
  }
}

export default Header;
